import {
  DocumentReference,
  isDocRef,
  isObject,
  TypeGuard,
} from '@principle-theorem/shared';
import {
  IAccInvoice,
  IAccInvoiceStatus,
  IAccInvoiceStatusDetails,
} from '../../acc/invoice/acc-invoice';
import { ITransaction } from '../../transaction';
import {
  FundingRequestProvider,
  FundingRequestType,
  IFundingRequest,
  isFundingRequest,
} from '../funding-request';
import { IInvoice } from '../../../invoice/invoice';
import { isBoolean, isString } from 'lodash';

export interface IAccInvoiceFundingRequestData {
  claimUid: string;
  transactions?: DocumentReference<ITransaction>[];
  invoiceRef?: DocumentReference<IInvoice>;
  invoice?: IAccInvoice;
  invoiceStatus?: IAccInvoiceStatus;
  invoiceStatusDetails?: IAccInvoiceStatusDetails[];
  testMode?: boolean;
}

export const isAccInvoiceFundingRequestData =
  TypeGuard.interface<IAccInvoiceFundingRequestData>({
    claimUid: isString,
    transactions: TypeGuard.undefinedOr(TypeGuard.arrayOf(isDocRef)),
    invoiceRef: TypeGuard.undefinedOr(isDocRef),
    invoice: TypeGuard.undefinedOr(isObject),
    invoiceStatus: TypeGuard.undefinedOr(isObject),
    invoiceStatusDetails: TypeGuard.undefinedOr(TypeGuard.arrayOf(isObject)),
    testMode: TypeGuard.undefinedOr(isBoolean),
  });

export type IAccInvoiceFundingRequest =
  IFundingRequest<IAccInvoiceFundingRequestData>;

export function isAccInvoiceFundingRequest(
  item: unknown
): item is IAccInvoiceFundingRequest {
  return (
    isFundingRequest(item) &&
    isAccInvoiceFundingRequestData(item.data) &&
    item.fundingProvider === FundingRequestProvider.ACC &&
    item.type === FundingRequestType.Claim
  );
}
